import useUsuario from "~fetchs/useUsuario";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, FieldArray } from "formik";

import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";
import mask from "~services/utils/mask";
import Select from "~components/Form/components/Select";
import prepareForOptions from "~services/utils/prepareForOptions";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";
import useModalStatus from "~components/Modal/hooks/useModalStatus";
import useProspectValidate from "../hooks/useProspectValidate";
import { initialPath } from "~misc/paths";
import { useSalvarProspect } from "../../hooks/useWallet";
import Loader from "~components/Form/components/Loader";
import ModalResponse from "~components/Modal/ModalResponse";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import { DeleteEdit } from "~misc/icons";
import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useSegmento from "~/fetchs/useSegmento";
import ExcluirModal from "~pages/PricesTable/components/Modal/ExcluirModal";
import { useNavigate } from "react-router-dom";
import { db } from "~/db/db";
import useCargo from "~/fetchs/useCargo";
import useProspect from "~/fetchs/useProspect";
import useSelect from "~components/Form/hooks/useSelect";
import useParametros from "~fetchs/useParametros";
import useMicrorregiao from "~fetchs/useMicrorregiao";
import { permiteNomeObra, normalizeNomeObra } from "~services/utils/nomeObra";

const { cpfCnpj } = mask();

const ProspectForm = () => {
  const { usuario } = useUsuario();
  const { setProspectCarteira } = useProspect();

  const newContato = {
    nome: "",
    sobrenome: "",
    cargoId: null,
    email: "",
    telefone: "",
    fonte: "",
  };

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();

  const [linkResponse, setLinkResponse] = useState(null);

  //States
  const [tipoPessoa, setTipoPessoa] = useState(0);
  const [prospectData, setProspectData] = useState({});

  const { formatNumber, dateMask } = mask();
  const { validationSchema, initialValues } = useProspectValidate(tipoPessoa);

  const [loading, setLoading] = useState(false);
  const formikRef = useRef();
  const ArrayContatoRef = useRef();
  const [prospectId, setProspectId] = useState(null);
  const [prospectCodigo, setProspectCodigo] = useState(null);

  // Requests
  const onSuccess = async (data) => {
    setProspectCarteira(data);
    setProspectId(data.id);
    setProspectCodigo(data.codigoProspect);
    setLoading(false);
    setLinkResponse(`${initialPath}/carteira/prospect`);
    setMessageStatus("Solicitação enviada com sucesso!");
    setSubmessageStatus("Verifique o status na aba minhas solicitações");
    openModal("success");
  };

  const onError = (err) => {
    setLoading(false);
    setLinkResponse(null);
    setMessageStatus("Ocorreu um erro ao cadastrar o prospect!");
    setSubmessageStatus(err.message)
    openModal("alert");
  };

  const prospectSalvar = useSalvarProspect(prospectData, onSuccess, onError);

  //IndexsDB
  const { optionsTrilha, trilha, trilhas, onChangeTrilha, trilhaSelect, trilhasObjId, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
  const { gruposCentralizadores } = useGrupoCentralizador(formikRef);
  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, onChangeGrupoSegmento } = useGrupoSegmento({ formikRef, trilha });
  const { optionsSegmento, segmentoSelect, onChangeSegmento } = useSegmento(grupoSegmento, formikRef);
  const { optionMicrorregioes, microrregiaoSelect, onChangeMicrorregiao } = useMicrorregiao({ formikRef });
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const grupoCentralizadorConstrutoraOptions = useMemo(() => {
    const filtrados = (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha);
    return prepareForOptions(filtrados, ["codigo", "nome"], "id");
  }, [gruposCentralizadores, trilha]);
  const filteredGrupoCentralizador = useMemo(() => (gruposCentralizadores || []).filter((g) => g.trilhaId === trilha), [gruposCentralizadores, trilha]);
  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);

  const loadGrupoOptions = useCallback(() => {
    if ( grupoOptionsLoaded ) return;
    setGrupoLoading(true);
    setTimeout(() => {
      const opts = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(opts);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 50);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);
  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);

  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId = trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;

  const infraTrilhaId = trilhasObjNome?.INFRA?.id ||trilhasObjCodigo?.INFRA?.id || trilhasObjCodigo?.["411"]?.id;
  const isTrilhaINFRA = infraTrilhaId ? String(trilha) === String(infraTrilhaId) : false;
  const isTrilhaIMOorINFRA = isTrilhaIMO || isTrilhaINFRA;
  const acessoJornadaFunil = isTrilhaIMOorINFRA && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const modalResponseRedirect = () => {
    if (modalStatus !== "success") {
      return;
    }

    if (acessoJornadaFunil && prospectId) {
      navigate(`${initialPath}/carteira/prospect/${prospectId}?jornada=cadastro`);
      return;
    }

    navigate(linkResponse);
  };

  const exibirNomeObra = permiteNomeObra(trilhasObjId?.[`key-${trilha}`]);
  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };

  const { optionsCargo, cargoSelect, handleCargoChange, SetSelectCargo } = useCargo(formikRef);


  const navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(prospectData).length > 0) {
      prospectSalvar();
    }
  }, [prospectData]);

  useEffect(() => {
    if (!formikRef.current) return;

    if (!isTrilhaPermitida) {
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoCentralizadorConstrutoraOptions?.length) return;

    const currentId = formikRef.current.values?.grupoCentralizadorConstrutoraId;
    if (currentId === null || currentId === undefined || currentId === "") return;

    const currentOption = grupoCentralizadorConstrutoraOptions.find(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, grupoCentralizadorConstrutoraOptions, trilha]);

  useEffect(() => {
      if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
        loadGrupoOptions();
      }
    }, [isTrilhaPermitida, filteredGrupoCentralizador, loadGrupoOptions]);

  //Functions
  function submit(values) {
    setProspectData({
      ...values,
      quantidadeTorres: null,
      volumePotencial: null,
      numeroPavimentos: null,
      dataNascimento: values.dataNascimento ? values.dataNascimento.split("/").reverse().join("-") : null,
      dataNegociacao: values.negociacaoDate ? values.negociacaoDate.split("/").reverse().join("-") : null,
      nomeObra: normalizeNomeObra(values.nomeObra, exibirNomeObra),
      ultimoEnvio: new Date().toLocaleString(),
    });
  }

  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }
  function HandleRemoveBlock(arrayContatos, index) {
    setIsConfirmationOpen(true);
    setIndexBlock(index);

    setremoveBlock((prevState) => ({
      // Mantenha os valores antigos do estado
      ...prevState,
      // Atualize o arrayContatos adicionando um novoContato
      arrayContatos: [...prevState.arrayContatos, arrayContatos],
      index: index,
    }));
  }

  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }

  const [cpfCnpjTeste, setCpfCnpj] = useState("");

  function onChangeCpfCnpj(value) {
    setCpfCnpj(value);
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setFieldError }) => {
        if (isTrilhaIMO && isTrilhaPermitida && !values.grupoCentralizadorConstrutoraId) {
          setFieldError(
            "grupoCentralizadorConstrutoraId",
            "Grupo Centralizador Construtoras e obrigatório"
          );
          return;
        }
        let buttonSubmit = document.querySelector(".send-button");
        buttonSubmit.classList.add("disabled-submit");
        setLoading(true);
        SaveIndexBD("form-new-prospect", values);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        submit(values);
      }}
      enableReinitialize
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => (
        <Form className="mt-[0rem] relative" id="prospect">
          <div className={loading ? "relative spinner__form-active" : "relative"}>
            <ContainerForm title="Dados Cadastrais">
              <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-12">
                <Select
                  name="trilhaId"
                  label="Trilha Global:"
                  placeholder="Trilha Global:"
                  options={optionsTrilha}
                  noOptionsMessage="Trilha não encontrado"
                  onChange={onChangeTrilha}
                  errors={errors.trilhaId}
                  touched={touched.trilhaId}
                  {...trilhaSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-4` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                <Select
                  name="grupoSegmentoId"
                  label="Grupo Segmento:"
                  placeholder="Grupo Segmento:"
                  options={optionsGrupoSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={onChangeGrupoSegmento}
                  isDisabled={!values.trilhaId}
                  errors={errors.grupoSegmentoId}
                  touched={touched.grupoSegmentoId}
                  {...grupoSegmentoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-4` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                <Select
                  name="segmentoId"
                  label="Segmento:"
                  placeholder="Segmento:"
                  options={optionsSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={onChangeSegmento}
                  isDisabled={!values.grupoSegmentoId}
                  errors={errors.segmentoId}
                  touched={touched.segmentoId}
                  {...segmentoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-4` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                {isTrilhaPermitida && (
                  <Select
                    name="grupoCentralizadorConstrutoraId"
                    label="Grupo Centralizador Construtoras:"
                    placeholder="Grupo Centralizador Construtoras:"
                    options={grupoOptionsLoaded ? grupoOptionsState : selectedGrupoOption ? [selectedGrupoOption] : []}
                    value={selectedGrupoOption}
                    onMenuOpen={loadGrupoOptions}
                    loading={grupoLoading}
                    isDisabled={grupoLoading || !values.trilhaId}
                    noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                    onChange={onChangeGrupoCentralizadorConstrutora}
                    errors={errors.grupoCentralizadorConstrutoraId}
                    touched={touched.grupoCentralizadorConstrutoraId}
                    isRequired={isTrilhaIMO}
                    {...grupoCentralizadorConstrutoraSelect}
                    className="col-span-12 sm:col-span-1 lg:col-span-6"
                  />
                )}
                <Select
                  name="microrregiaoId"
                  label="Microrregião:"
                  placeholder="Microrregião:"
                  options={optionMicrorregioes}
                  noOptionsMessage="Microrregião não encontrada"
                  onChange={onChangeMicrorregiao}
                  errors={errors.microrregiaoId}
                  touched={touched.microrregiaoId}
                  {...microrregiaoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-2 lg:col-span-6` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                />
              </div>
              <div className={`grid gap-x-4 md:grid-cols-1 lg:grid-cols-${tipoPessoa == 1 ? "4" : "3"}`}>
                <Select
                  name="tipo"
                  label="Tipo Pessoa:"
                  placeholder="Tipo Pessoa:"
                  options={[
                    {
                      value: 1,
                      label: "CPF - Pessoa Fisica",
                    },
                    {
                      value: 2,
                      label: "CNPJ - Pessoa Juridica",
                    },
                  ]}
                  onChange={(e) => {
                    setFieldValue("tipo", e.value);
                    setTimeout(() => setFieldTouched("tipo", true));
                    setTipoPessoa(e.value);
                  }}
                  errors={errors.tipo}
                  touched={touched.tipo}
                  isRequired
                />
                <InputField
                  labelName="CNPJ/CPF:"
                  inputName="documento"
                  as={MaskedInput}
                  mask={cpfCnpj}
                  inputMask="onmask"
                  inputType="text"
                  forceUppercase
                  onBlur={() => onChangeCpfCnpj(values.documento)}
                />
                <InputField
                  labelName={`Nome ${tipoPessoa != 1 ? "Fantasia" : ""}:`}
                  inputName="nomeFantasia"
                  inputMask="offmask"
                  inputType="text"
                  isRequired
                />
                {/* Apenas pessoa física tem data de nascimento */}
                {tipoPessoa == 1 && (
                  <InputField
                    labelName="Data de Nascimento:"
                    inputName="dataNascimento"
                    as={MaskedInput}
                    mask={dateMask}
                    inputMask="onmask"
                    inputType="text"
                    isRequired={tipoPessoa == 1}
                  />
                )}
              </div>
              <AddressForm formikRef={formikRef} />
              {exibirNomeObra && (
                <InputField labelName="Nome da Obra:" inputName="nomeObra" inputMask="offmask" inputType="text" />
              )}
            </ContainerForm>
            <FieldArray
              name="contatos"
              render={(arrayContatos) => {
                ArrayContatoRef.current = arrayContatos;
                return (
                  <div className="container relative">
                    <ContainerForm title="Dados Pessoais">
                      {values.contatos.map((data, index) => (
                        <>
                          <div
                            className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                              } ${values.contatos.length > 1 ? " pt-12 " : ""}`}
                            key={index}
                          >
                            {values.contatos.length > 1 && (
                              <button
                                type="button"
                                className="scale-75 absolute top-0 right-0"
                                onClick={() => HandleRemoveBlock(arrayContatos, index)}
                              >
                                <DeleteEdit />
                              </button>
                            )}
                            <InputField
                              labelName="Nome Contato:"
                              inputName={`contatos[${index}].nome`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Sobrenome Contato:"
                              inputName={`contatos[${index}].sobrenome`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <Select
                              name={`contatos[${index}].cargoId`}
                              label="Cargo:"
                              placeholder=""
                              options={optionsCargo}
                              onChange={(e) => {
                                setFieldValue(`contatos[${index}].cargoId`, e.value);
                                setFieldValue(`contatos[${index}].cargo`, e.label);
                                setTimeout(() => setFieldTouched(`contatos[${index}].cargoId`, true));
                              }}
                              errors={errors.contatos && errors?.contatos[index]?.cargoId}
                              touched={touched.contatos && touched?.contatos[index]?.cargoId}
                              isRequired
                            />
                            <InputField
                              labelName="Email do Contato:"
                              inputName={`contatos[${index}].email`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 1:"
                              inputName={`contatos[${index}].telefone`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 2:"
                              inputName={`contatos[${index}].celular`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              difference={true}
                            />
                          </div>
                          <div className="flex items-center">
                            {((values.contatos.length > 1 && index == values.contatos.length - 1) ||
                              values.contatos.length == 1) && (
                                <button
                                  type="button"
                                  className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search "
                                  onClick={() => arrayContatos.push(newContato)}
                                >
                                  Adicionar um novo Contato
                                </button>
                              )}
                          </div>
                        </>
                      ))}
                    </ContainerForm>
                  </div>
                );
              }}
            ></FieldArray>
          </div>
          {loading && (
            <>
              <div className="spinner__form">
                <Loader />
              </div>
            </>
          )}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />

          <ModalResponse
            isOpen={isModalOpen}
            closeModal={(e) => {
              modalResponseRedirect();
              closeModal();
            }}
            status={modalStatus}
            message={messageStatus}
            submessage={submessageStatus}
            button="Ok"
          />

          <ExcluirModal
            isOpen={isConfirmationOpen}
            onClose={HandleRemoveBlockClosed}
            onConfirm={RemoveBlock}
            onCancel={HandleRemoveBlockClosed}
            mensagem={`Tem certeza de que deseja excluir o bloco ${indexBlock}`}
          />

        </Form>
      )}
    </Formik>
  );
};

export default ProspectForm;
